export const CHECKOUT_RESERVED_ASSET = 'check_out_reserved_asset';